<template>
    <v-autocomplete v-model="form.minute" v-bind="{ ...$attrs, items }" @input="emit" />
</template>

<script>
const initForm = (form = {}) => ({
    ...(form || {}),

    hour: form?.hour ?? 10,
    minute: form?.minute ?? 0,
});
export default {
    props: {
        value: { type: Object, default: initForm },
    },
    data: () => ({
        form: initForm(),

        items: new Array(60).fill("").map((_, index) => ({
            text: `${index.toString().padStart(2, "0")}분`,
            value: index,
        })),
    }),
    methods: {
        sync() {
            this.form = initForm(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style>
</style>